// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import { Image } from "theme-ui"
import { mediaQueries } from "../../utils/theme/media-queries"
import { colors } from "../../utils/theme/colors"
import { fontWeights } from "../../utils/theme/font-weights"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import AmazonPic from "../../images/amazon.png"
import Container from "../layout/container"
import benefitsContent from "../../content/agence-amazon/benefits.json"
import Span from "../common/span"

const Card = ({ title, content, img, width }) => (
  <div
    sx={{
      borderRadius: `8px`,
      border: `solid 1px #909194`,
      backgroundColor: `#f5fafd`,
      marginBottom: `2rem`,
      marginTop: [`5rem`, `5rem`, `0rem`, `0rem`],
      width: [null, null, `30.5rem`, `30.5rem`],
    }}
  >
    <div
      sx={{ marginTop: `-7.2rem`, display: `flex`, justifyContent: `center` }}
    >
      <Img fixed={img} sx={{ width: width }} />
    </div>
    <div
      sx={{
        marginTop: `3rem`,
        paddingLeft: [`1rem`, `1rem`, `2.5rem`, `2.5rem`],
        paddingRight: [`1rem`, `1rem`, `2.5rem`, `2.5rem`],
      }}
    >
      <h3
        sx={{
          fontSize: `1.3rem`,
          color: colors.code.secondary,
          fontWeight: fontWeights.black,
          textAlign: `center`,
        }}
      >
        {title}
      </h3>
      <p
        sx={{
          fontSize: `0.938rem`,
          color: colors.code.secondary,
          textAlign: `center`,
        }}
      >
        {content}
      </p>
    </div>
  </div>
)

const Benefits = ({ langKey }) => {
  const data = useStaticQuery(graphql`
    query BenefitsQuery {
      SeelkLogo: file(relativePath: { eq: "logo-separator.png" }) {
        childImageSharp {
          fixed(width: 35, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      Card1Pic: file(
        relativePath: { eq: "illustration-conseil-strategie.png" }
      ) {
        childImageSharp {
          fixed(height: 190, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      Card2Pic: file(relativePath: { eq: "EquipeExperts.png" }) {
        childImageSharp {
          fixed(height: 190, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  const {
    title,
    title1,
    card1title,
    card1subtitle,
    card2title,
    card2subtitle,
    amazonDescription,
    title2,
    title3,
  } = benefitsContent[langKey]

  return (
    <Container>
      <div
        sx={{
          display: `flex`,
          flexDirection: `column`,
          paddingTop: `4rem`,
          [mediaQueries.lg]: { paddingTop: `10rem` },
        }}
      >
        <div
          sx={{
            height: [`3rem`, `3rem`, `7rem`, `7rem`],
            borderLeft: `1px solid orange`,
            margin: `auto`,
            my: `1rem`,
          }}
        />
        <div sx={{ alignSelf: `center`, [mediaQueries.lg]: { width: `30%` } }}>
          <h2
            sx={{
              color: colors.code.secondary,
              textAlign: `center`,
              fontWeight: fontWeights.black,
              fontSize: [`1.375rem`, `1.375rem`, `2.25rem`, `2.25rem`],
            }}
          >
            {title}&nbsp;
            <Span text={title1} />
          </h2>
        </div>

        <div
          sx={{
            alignSelf: `center`,
            marginBottom: [`7rem`, `7rem`, `10rem`, `10rem`],
          }}
        >
          <Img fixed={data.SeelkLogo.childImageSharp.fixed} alt="" />
        </div>
        <div
          sx={{
            width: [null, null, `63rem`, `63rem`],
            margin: `auto`,
          }}
        >
          <div
            sx={{
              display: `flex`,
              justifyContent: `space-around`,
              flexDirection: [`column`, `column`, `row`, `row`],
            }}
          >
            <Card
              title={card1title}
              content={card1subtitle}
              img={data.Card2Pic.childImageSharp.fixed}
              width={`14rem`}
            />
            <Card
              title={card2title}
              content={card2subtitle}
              img={data.Card1Pic.childImageSharp.fixed}
              width={`10rem`}
            />
          </div>
          <div
            sx={{
              display: `flex`,
              marginBottom: `6.7rem`,
              borderRadius: `8px`,
              border: `solid 1px `,
              width: [null, null, `100%`, `100%`],
              overflow: `hidden`,
              height: [`11.5rem`, `11.5rem`, `8.75rem`, `8.75rem`],
              alignSelf: `center`,
              flexDirection: [`column`, `column`, `row`, `row`],
            }}
          >
            <div
              sx={{
                display: `flex`,
                backgroundColor: `#f5fafd`,
                alignItems: `center`,
                justifyContent: `center`,
                [mediaQueries.lg]: { width: `50%` },
              }}
            >
              <Image
                src={AmazonPic}
                sx={{ width: `17.75rem`, height: `6.13rem` }}
              />
            </div>
            <div
              sx={{
                display: `flex`,
                backgroundColor: colors.code.secondary,
                justifyContent: `center`,
                alignItems: `center`,
                height: `5.5rem`,
                [mediaQueries.lg]: { width: `50%`, height: `auto` },
              }}
            >
              <p
                sx={{
                  color: colors.white,
                  margin: 0,
                  paddingLeft: [`0.5rem`, `0.5rem`, `2rem`, `2rem`],
                  paddingRight: [`0.5rem`, `0.5rem`, `2rem`, `2rem`],
                }}
              >
                {amazonDescription}
              </p>
            </div>
          </div>
        </div>
        <div
          sx={{
            alignSelf: `center`,
            width: `90%`,
            [mediaQueries.lg]: { width: `40%` },
          }}
        >
          <h3
            sx={{
              color: colors.code.secondary,

              fontSize: `1.38rem`,
              fontWeight: fontWeights.black,
              textAlign: `center`,
              [mediaQueries.lg]: { fontSize: `2.25rem` },
            }}
          >
            {title2}&nbsp;
            <Span text={title3} />
          </h3>
        </div>
      </div>
    </Container>
  )
}

export default Benefits
